var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49509 9.5165C5.46309 11.7155 5.50609 15.2015 7.62409 17.3605C8.65809 18.4175 10.0321 19.0005 11.4961 19.0015H11.5011C12.9681 19.0015 14.3471 18.4185 15.3861 17.3605C17.5421 15.1625 17.5381 11.5875 15.3771 9.3925L12.3911 6.3415C12.0891 8.8235 11.1581 11.0015 9.50009 11.0015C8.99209 11.0015 8.16409 10.7755 7.49509 9.5165ZM11.5011 21.0015H11.4941C9.48809 20.9995 7.60609 20.2045 6.19509 18.7595C3.28109 15.7895 3.27709 10.9565 6.18609 7.9915L7.16909 6.9975C7.42309 6.7435 7.79209 6.6455 8.14109 6.7365C8.48809 6.8305 8.75809 7.1035 8.84809 7.4515C9.07809 8.3405 9.35209 8.7775 9.50309 8.9435C9.85809 8.5695 10.5001 7.0585 10.5001 4.5015C10.5001 4.3545 10.5001 4.2155 10.4921 4.0765C10.4731 3.7815 10.5861 3.4925 10.8001 3.2885C11.1971 2.9115 11.8331 2.9115 12.2141 3.3035L16.8041 7.9925C19.7241 10.9565 19.7291 15.7895 16.8141 18.7605C15.3951 20.2065 13.5091 21.0015 11.5011 21.0015Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.904145fac8ecadab50a3c1ccd7df631c.svg";
export { ForwardRef as ReactComponent };